import axios from "axios";
import Crypto from "./utils/crypto.js";
import prefixPath from "./utils/prefixPath";
import inHospitalUtils from "./utils/inHospital.js";
import record from "./sdkV2/record";
import form from "./sdkV2/form";
import inHospitalV2 from "./sdkV2/inHospitalV2";
import inHospital from "./sdkV2/inHospital";
import todo from "./sdkV2/todo";
import booking from "./sdkV2/booking";
import referral from "./sdkV2/referral";
import schedule from "./sdkV2/schedule";
import customize from "./sdkV2/customize";
import customizeForm from "./sdkV2/customizeForm";
import role from "./sdkV2/role";
import staff from "./sdkV2/staff";
import user from "./sdkV2/user";
import pet from "./sdkV2/pet";
import reminder from "./sdkV2/reminder.js";
import setting from "./sdkV2/setting";
import payment from "./sdkV2/payment";
import settingBooking from "./sdkV2/settingBooking";
import surgeryMonitor from "./sdkV2/surgeryMonitor";
import sudo from "./sdkV2/sudo";
import billing from "./sdkV2/billing";
import pdf from "./sdkV2/pdf";
import csv from "./sdkV2/csv";
import excel from "./sdkV2/excel";
import clockin from "./sdkV2/clockin";
import ip from "./sdkV2/ip";
import web from "./sdkV2/web";
import clinic from "./sdkV2/clinic";
import checkout from "./sdkV2/checkout";
// import config from "./sdkV2/config";
import synctool from "./sdkV2/synctool";
import basic from "./sdkV2/basic";
import deposit from "./sdkV2/deposit";
import exam from "./sdkV2/exam";
import external from "./sdkV2/external";
import verifyData from "./sdkV2/verify";
import verifyV2Data from "./sdkV2/verifyV2";
import alliance from "./sdkV2/alliance";
import linepay from "./sdkV2/linepay";
import webLog from "./sdkV2/webLog.js";
import service from "./sdkV2/service.js";
import supplier from "./sdkV2/supplier.js";
import product from "./sdkV2/product.js";
import PetFile from "./sdkV2/petFile.js";
import Oauth from "./sdkV2/oauth.js";

import {
  // getFocusClinic,
  // getEmulateUser,
  updatePrint,
  getPrintData,
  hasBillItem,
  b64toBlob,
} from "./utils/common";

import {
  RTN_MSG,
  PET_STATUS_LIST,
  PET_LIGATION_LIST,
  PET_GENDER_LIST,
  RECORD_STATUS,
  IN_HOSPITAL_STATUS,
  ARCHIVE_STATUS,
  EXECUTION_STATUS,
  VERIFY_STATUS,
  ROLE_ADMIN_PREFIX,
} from "./utils/emunData";
import {
  removeHttpErrorListener,
  addHttpErrorListener,
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
} from "./utils/http";
import md5 from "md5";

/**
 * 錯誤訊息對應
 */
// const RTN_MSG = {
//   100000: "成功",
//   900000: "發生錯誤",
//   100100: "登入成功",
//   100101: "帳號密碼錯誤",
//   100102: "沒有可以驗證的服務，請檢查網路連線",
//   100103: "未登入",
//   100104: "需要網路連線",
//   100105: "缺少必要參數",
//   100106: "登入帳號沒有可用的診所",
//   100107: "登入使用者資料錯誤",
//   100108: "無存取該資料庫的權限",
//   100109: "查無用戶資訊",
//   100404: "找不到可以操作的資源",
//   200001: "飼主 UserID 有誤",
//   200002: "缺少查詢品種條件",
//   200003: "寵物 petID 有誤",
//   200004: "飼主電話重複",
//   200005: "使用者已經註冊, Email 重複",
//   200006: "註冊失敗，員工數已達上限",
//   200007: "雲端儲存空間額度已滿",
// };

class SDK {
  // instance fields
  KEY = "NxVetKey";
  apiEndpoint = undefined;
  webEndpoint = undefined;
  dbEndpoint = undefined;
  recordApis = undefined;
  formApis = undefined;
  inHospitalV2Apis = undefined;
  inHospitalApis = undefined;
  todoApis = undefined;
  bookingApis = undefined;
  referralApis = undefined;
  scheduleApis = undefined;
  customizeApis = undefined;
  customizeFormApis = undefined;
  roleApis = undefined;
  staffApis = undefined;
  userApis = undefined;
  petApis = undefined;
  reminderApis = undefined;
  settingApis = undefined;
  settingBookingApis = undefined;
  webApis = undefined;
  surgeryMonitorApis = undefined;
  paymentApis = undefined;
  sudoApis = undefined;
  pdfApis = undefined;
  csvApis = undefined;
  excelApis = undefined;
  ipApis = undefined;
  prefixPathApis = undefined;
  clockinApis = undefined;
  billingApis = undefined;
  clinicApis = undefined;
  checkoutApis = undefined;
  // configApis = undefined;
  synctoolApis = undefined;
  basicApis = undefined;
  depositApis = undefined;
  examApis = undefined;
  externalApis = undefined;
  verifyApis = undefined;
  allianceApis = undefined;
  linepayApis = undefined;
  webLogApis = undefined;
  serviceApis = undefined;
  supplierApis = undefined;
  productApis = undefined;
  petFileApis = undefined;
  oauthApis = undefined;

  RECORD_STATUS = RECORD_STATUS;
  IN_HOSPITAL_STATUS = IN_HOSPITAL_STATUS;
  archiveStatus = ARCHIVE_STATUS;
  executionStatus = EXECUTION_STATUS;
  VERIFY_STATUS = VERIFY_STATUS;
  ROLE_ADMIN_PREFIX = ROLE_ADMIN_PREFIX;

  constructor(options) {
    if (!options) {
      throw "Please specify constructor options";
    }
    this.setApiEndpoint(SDK.findProperApiEndpoint(options.hostname));
    this.webEndpoint = SDK.findProperWebEndpoint(options.hostname);
    this.dbEndpoint = SDK.findProperDBEndpoint(options.hostname);

    console.log("NxVetSDK initialized");
  }

  setApiEndpoint(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
    this.recordApis = new record(this.apiEndpoint);
    this.formApis = new form(this.apiEndpoint);
    this.inHospitalV2Apis = new inHospitalV2(this.apiEndpoint);
    this.inHospitalApis = new inHospital(this.apiEndpoint);
    this.todoApis = new todo(this.apiEndpoint);
    this.bookingApis = new booking(this.apiEndpoint);
    this.referralApis = new referral(this.apiEndpoint);
    this.scheduleApis = new schedule(this.apiEndpoint);
    this.roleApis = new role(this.apiEndpoint);
    this.staffApis = new staff(this.apiEndpoint);
    this.customizeApis = new customize(this.apiEndpoint);
    this.customizeFormApis = new customizeForm(this.apiEndpoint);
    this.userApis = new user(this.apiEndpoint);
    this.petApis = new pet(this.apiEndpoint);
    this.reminderApis = new reminder(this.apiEndpoint);
    this.settingBookingApis = new settingBooking(this.apiEndpoint);
    this.settingApis = new setting(this.apiEndpoint);
    this.webApis = new web(this.apiEndpoint);
    this.prefixPathApis = new prefixPath(this.apiEndpoint);
    this.surgeryMonitorApis = new surgeryMonitor(this.apiEndpoint);
    this.sudoApis = new sudo(this.apiEndpoint);
    this.pdfApis = new pdf(this.apiEndpoint);
    this.csvApis = new csv(this.apiEndpoint);
    this.clockinApis = new clockin(this.apiEndpoint);
    this.excelApis = new excel(this.apiEndpoint);
    this.ipApis = new ip(this.apiEndpoint);
    this.paymentApis = new payment(this.apiEndpoint);
    this.billingApis = new billing(this.apiEndpoint);
    this.clinicApis = new clinic(this.apiEndpoint);
    this.checkoutApis = new checkout(this.apiEndpoint);
    // this.configApis = new config(this.apiEndpoint);
    this.synctoolApis = new synctool(this.apiEndpoint);
    this.basicApis = new basic(this.apiEndpoint);
    this.depositApis = new deposit(this.apiEndpoint);
    this.examApis = new exam(this.apiEndpoint);
    this.externalApis = new external(this.apiEndpoint);
    this.verifyApis = new verifyData(this.apiEndpoint);
    this.verifyV2Apis = new verifyV2Data(this.apiEndpoint);
    this.allianceApis = new alliance(this.apiEndpoint);
    this.linepayApis = new linepay(this.apiEndpoint);
    this.webLogApis = new webLog(this.apiEndpoint);
    this.serviceApis = new service(this.apiEndpoint);
    this.supplierApis = new supplier(this.apiEndpoint);
    this.productApis = new product(this.apiEndpoint);
    this.petFileApis = new PetFile(this.apiEndpoint);
    this.oauthApis = new Oauth(this.apiEndpoint);
  }

  /**
   * Find the proper api endpoint based on hostname
   */
  static findProperApiEndpoint(hostname) {
    if (hostname) {
      switch (hostname) {
        // development site
        case "dev.nxvet.io":
        case "node3.nxvet.io":
          return "https://dev.nxvet.io";
        // production site
        case "nxvet.io":
        case "www.nxvet.io":
        case "node4.nxvet.io":
          return "https://nxvet.io";
        // production s2 site
        case "s2.nxvet.io":
        case "node5.nxvet.io":
          return "https://s2.nxvet.io";
        // production s3 site
        case "s3.nxvet.io":
        case "node6.nxvet.io":
          return "https://s3.nxvet.io";
        // production s4 site
        case "s4.nxvet.io":
        case "node7.nxvet.io":
          return "https://s4.nxvet.io";
        // production s4m site
        case "s4m.nxvet.io":
          return "https://s4m.nxvet.io";
        // production s5 site
        case "s5.nxvet.io":
          return "https://s5.nxvet.io";
        // production s6 site
        case "s6.nxvet.io":
          return "https://s6.nxvet.io";
        // production s7 site
        case "s7.nxvet.io":
          return "https://s7.nxvet.io";
        // production s99 site
        case "s99.nxvet.io":
          return "https://s99.nxvet.io";
        // inside docker
        case "nxvet-haproxy":
        case "nxvet-web":
          return "http://nxvet-api:5983";
      }
      if (hostname.indexOf("192.168") != -1) return `http://${hostname}:5983`;
    }

    // all the other cases
    return "http://127.0.0.1:5983";
  }

  /**
   * Find the proper web endpoint based on hostname
   */
  static findProperWebEndpoint(hostname) {
    if (hostname) {
      switch (hostname) {
        // development site
        case "dev.nxvet.io":
        case "node3.nxvet.io":
          return "https://dev.nxvet.io/app";
        // production site
        case "nxvet.io":
        case "www.nxvet.io":
        case "node4.nxvet.io":
          return "https://nxvet.io/app";
        // production s2 site
        case "s2.nxvet.io":
        case "node5.nxvet.io":
          return "https://s2.nxvet.io/app";
        // production s3 site
        case "s3.nxvet.io":
        case "node6.nxvet.io":
          return "https://s3.nxvet.io/app";
        // production s4 site
        case "s4.nxvet.io":
        case "node7.nxvet.io":
          return "https://s4.nxvet.io/app";
        // production s4m site
        case "s4m.nxvet.io":
          return "https://s4m.nxvet.io/app";
        // production s5 site
        case "s5.nxvet.io":
          return "https://s5.nxvet.io/app";
        // production s6 site
        case "s6.nxvet.io":
          return "https://s6.nxvet.io/app";
        // production s7 site
        case "s7.nxvet.io":
          return "https://s7.nxvet.io/app";
        // production s99 site
        case "s99.nxvet.io":
          return "https://s99.nxvet.io/app";
      }
      if (hostname.indexOf("192.168") != -1) return `http://${hostname}:8080`;
    }

    // all the other cases
    return "http://127.0.0.1:8080";
  }

  /**
   * Find the proper web endpoint based on hostname
   */
  static findProperDBEndpoint(hostname) {
    if (hostname) {
      switch (hostname) {
        // development site
        case "dev.nxvet.io":
        case "node3.nxvet.io":
          return "https://db-dev.nxvet.io";
        // production site
        case "nxvet.io":
        case "www.nxvet.io":
        case "node4.nxvet.io":
          return "https://db.nxvet.io";
        // production s2 site
        case "s2.nxvet.io":
        case "node5.nxvet.io":
          return "https://db-s2.nxvet.io";
        // production s3 site
        case "s3.nxvet.io":
        case "node6.nxvet.io":
          return "https://db-s3.nxvet.io";
        // production s4 site
        case "s4.nxvet.io":
        case "node7.nxvet.io":
          return "https://db-s4.nxvet.io";
        // production s4m site
        case "s4m.nxvet.io":
          return "https://db-s4m.nxvet.io";
        // production s5 site
        case "s5.nxvet.io":
          return "https://db-s5.nxvet.io";
        // production s6 site
        case "s6.nxvet.io":
          return "https://db-s6.nxvet.io";
        // production s7 site
        case "s7.nxvet.io":
          return "https://db-s7.nxvet.io";
        // production s99 site
        case "s99.nxvet.io":
          return "https://db-s99.nxvet.io";
        // inside docker
        case "nxvet-haproxy":
        case "nxvet-web":
          return "http://nxvet-pouchdb:5984";
      }
      if (hostname.indexOf("192.168") != -1) return `http://${hostname}:5984`;
    }

    // all the other cases
    return "http://127.0.0.1:5984";
  }

  getBasicAuthHeaders() {
    let username = Crypto.decrypt(
      localStorage.getItem("LAST_USERNAME"),
      this.KEY
    );

    let password = Crypto.decrypt(
      localStorage.getItem("LAST_PASSWORD"),
      this.KEY
    );

    return {
      headers: {
        Authorization: "Basic " + btoa(username + ":" + password),
      },
    };
  }

  createPetIndex(data) {
    if (typeof data !== "object") {
      return { code: 100105, message: RTN_MSG["100105"] };
    }

    let apiUrl = `${this.apiEndpoint}/api/sdk/${localStorage.getItem(
      "CLINIC"
    )}/petIndex`;
    let config = this.getBasicAuthHeaders();

    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl, data, config)
        .then(function (response) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: response.data,
          });
        })
        .catch(function (error) {
          reject({ code: 900000, message: RTN_MSG["900000"], result: error });
        });
    });
  }

  updatePetIndex(data) {
    if (typeof data !== "object") {
      return { code: 100105, message: RTN_MSG["100105"] };
    }

    let apiUrl = `${this.apiEndpoint}/api/sdk/${localStorage.getItem(
      "CLINIC"
    )}/petIndex`;
    let config = this.getBasicAuthHeaders();

    return new Promise((resolve, reject) => {
      axios
        .put(apiUrl, data, config)
        .then(function (response) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: response.data,
          });
        })
        .catch(function (error) {
          reject({ code: 900000, message: RTN_MSG["900000"], result: error });
        });
    });
  }

  deletePetIndex(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/${localStorage.getItem(
      "CLINIC"
    )}/petIndex`;
    let config = this.getBasicAuthHeaders();
    config.data = data;

    return new Promise((resolve, reject) => {
      axios
        .delete(apiUrl, config)
        .then(function (response) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: response.data,
          });
        })
        .catch(function (error) {
          reject({ code: 900000, message: RTN_MSG["900000"], result: error });
        });
    });
  }

  /**
   *
   * @deprecated move to indexDA
   * @returns {Promise}
   */
  createUserIndex(data) {
    if (typeof data !== "object") {
      return { code: 100105, message: RTN_MSG["100105"] };
    }

    let apiUrl = `${this.apiEndpoint}/api/sdk/${localStorage.getItem(
      "CLINIC"
    )}/userIndex`;
    let config = this.getBasicAuthHeaders();

    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl, data, config)
        .then(function (response) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: response.data,
          });
        })
        .catch(function (error) {
          reject({ code: 900000, message: RTN_MSG["900000"], result: error });
        });
    });
  }

  /**
   * @deprecated move to indexDA
   * other usage: touchUserAndPet
   * */
  updateUserIndex(data) {
    if (typeof data !== "object") {
      return { code: 100105, message: RTN_MSG["100105"] };
    }

    let apiUrl = `${this.apiEndpoint}/api/sdk/${localStorage.getItem(
      "CLINIC"
    )}/userIndex`;
    let config = this.getBasicAuthHeaders();

    return new Promise((resolve, reject) => {
      axios
        .put(apiUrl, data, config)
        .then(function (response) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: response.data,
          });
        })
        .catch(function (error) {
          reject({ code: 900000, message: RTN_MSG["900000"], result: error });
        });
    });
  }

  deleteUserIndex(id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/${localStorage.getItem(
      "CLINIC"
    )}/userIndex/${Crypto.encrypt(id, this.KEY)}`;
    let config = this.getBasicAuthHeaders();

    return new Promise((resolve, reject) => {
      axios
        .delete(apiUrl, config)
        .then(function (response) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: response.data,
          });
        })
        .catch(function (error) {
          reject({ code: 900000, message: RTN_MSG["900000"], result: error });
        });
    });
  }

  /**
   * @deprecated move to indexDA
   * other usage: modifyPet
   * */
  transferUserIndexPetID(data) {
    if (typeof data !== "object") {
      return { code: 100105, message: RTN_MSG["100105"] };
    }

    let apiUrl = `${this.apiEndpoint}/api/sdk/${localStorage.getItem(
      "CLINIC"
    )}/userIndex/transferPetID`;
    let config = this.getBasicAuthHeaders();

    return new Promise((resolve, reject) => {
      axios
        .put(apiUrl, data, config)
        .then(function (response) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: response.data,
          });
        })
        .catch(function (error) {
          reject({ code: 900000, message: RTN_MSG["900000"], result: error });
        });
    });
  }

  /**
   * @deprecated move to indexDA
   * other usage: modifyPet
   * */
  getOauthCode() {
    let apiUrl = `${this.apiEndpoint}/api/oauth/code`;
    let config = this.getBasicAuthHeaders();

    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl, config)
        .then(function (response) {
          resolve({
            code: 100000,
            message: RTN_MSG["100000"],
            result: response.data,
          });
        })
        .catch(function (error) {
          reject({ code: 900000, message: RTN_MSG["900000"], result: error });
        });
    });
  }

  removeHttpErrorListener = (cb) => removeHttpErrorListener(cb);
  addHttpErrorListener = (cb) => addHttpErrorListener(cb);
  //********************* common *************************/
  batchRead = (startkey, endkey) => {
    if (startkey.match(/^\/inHospital\/\d+\/exam\/\d+\/$/)) {
      //指定日期住院檢驗
      const inHospitalID = startkey.replace(/\/exam.*/, "");
      const planDateTime = startkey.replace(/^.*exam\//, "").replace(/\D/, "");
      return this.inHospitalV2Apis.getInHospitalExamListVer2(
        inHospitalID,
        planDateTime
      );
    } else if (startkey.match(/^\/inHospital\/\d+\/exam\/$/)) {
      //所有住院檢驗
      const inHospitalID = startkey.replace(/\/exam.*/, "");
      return this.inHospitalV2Apis.getInHospitalExamListVer2(inHospitalID);
    } else if (startkey.match(/^\/inHospital\/\d+\/plan\/$/)) {
      //所有住院醫囑
      const inHospitalID = startkey.replace(/\/plan.*/, "");
      return this.inHospitalV2Apis.getInHospitalPlanListVer2(inHospitalID);
    } else if (startkey.match(/^\/inHospital\/\d+\/missionLog\/$/)) {
      //所有住院執行紀錄
      const inHospitalID = startkey.replace(/\/missionLog.*/, "");
      return this.inHospitalV2Apis.getInHospitalMissionLogListVer2(
        inHospitalID
      );
    }
  };

  batchReadKeys = (keys) => {
    let userKeys = [];
    let petKeys = [];
    let recordKeys = [];
    let inHospitalKeys = [];

    keys
      .filter((key) => key)
      .forEach((key) => {
        if (key.startsWith("/user/")) {
          userKeys.push(key);
        } else if (key.startsWith("/pet/")) {
          petKeys.push(key);
        } else if (key.startsWith("/record/")) {
          recordKeys.push(key);
        } else if (key.startsWith("/inHospital/")) {
          inHospitalKeys.push(key);
        }
      });

    let promiseArray = [];
    if (petKeys.length) {
      promiseArray.push(this.petApis.getBulkPet(petKeys));
    }
    if (userKeys.length) {
      promiseArray.push(this.userApis.getBulkUser(userKeys));
    }
    if (recordKeys.length) {
      promiseArray.push(this.recordApis.getBulkRecord(recordKeys));
    }
    if (inHospitalKeys.length) {
      promiseArray.push(
        this.inHospitalV2Apis.getBulkInHospital(inHospitalKeys)
      );
    }

    if (promiseArray.length) {
      return new Promise((resolve, reject) => {
        try {
          Promise.all(promiseArray).then((resArray) => {
            let result = [];
            resArray.forEach((res) => (result = result.concat(res.result)));
            resolve({ result });
          });
        } catch (error) {
          reject(error);
        }
      });
    } else {
      return Promise.resolve({ result: [] });
    }
  };
  //*********************  Record  *********************//
  checkInRecord = (...args) => this.recordApis.checkInRecord(...args);

  checkInRecordUpdate = (...args) =>
    this.recordApis.checkInRecordUpdate(...args);

  createRecord = async (...args) => {
    let res = await this.recordApis.createRecord(...args);
    if (res.code === 100000 && res.result)
      this.prependRecordResourcePath([res.result]);
    return res;
  };

  modifyRecord = async (...args) => {
    let res = await this.recordApis.modifyRecord(...args);
    if (res.code === 100000 && res.result)
      this.prependRecordResourcePath([res.result]);
    return res;
  };

  purgeRecord = async (...args) => this.recordApis.purgeRecord(...args);

  getRecord = async (...args) => {
    let res = await this.recordApis.getRecord(...args);
    if (res.code === 100000 && res.result)
      this.prependRecordResourcePath([res.result]);
    return res;
  };
  copyRecord = async (...args) => this.recordApis.copyRecord(...args);

  getRecordListForInit = async (...args) => {
    let res = await this.recordApis.getRecordListForInit(...args);
    if (res.code === 100000 && res.result)
      this.prependRecordResourcePath(res.result);
    return res;
  };

  getRecordListByPet = async (...args) =>
    await this.recordApis.getRecordListByPet(...args);

  getRecordListByDateTime = async (...args) =>
    this.recordApis.getRecordListByDateTime(...args);

  getRecordListByConditions = async (...args) =>
    this.recordApis.getRecordListByConditions(...args);

  getRecordByStatusUpdateDateTime = async (...args) => {
    let res = await this.recordApis.getRecordByStatusUpdateDateTime(...args);
    if (res.code === 100000 && res.result)
      this.prependRecordResourcePath(res.result);
    return res;
  };

  getTodoRecordDrugList = async (...args) => {
    let res = await this.recordApis.getTodoRecordDrugList(...args);
    if (res.code === 100000 && res.result)
      this.prependRecordResourcePath(res.result);
    return res;
  };

  getTodoRecordExamList = async (...args) => {
    let res = await this.recordApis.getTodoRecordExamList(...args);
    if (res.code === 100000 && res.result)
      this.prependRecordResourcePath(res.result.docs);
    return res;
  };

  getRecordBilling = (...args) => this.recordApis.getRecordBilling(...args);
  getRecordStat = (...args) => this.recordApis.getRecordStat(...args);

  generateExtensionTask = (...args) =>
    this.recordApis.generateExtensionTask(...args);

  generateEBMExtensionTask = (...args) =>
    this.recordApis.generateEBMExtensionTask(...args);

  generateEPSPIExtensionTask = (...args) =>
    this.recordApis.generateEPSPIExtensionTask(...args);

  generateEPSPIWebviewerExtensionTask = (...args) =>
    this.recordApis.generateEPSPIWebviewerExtensionTask(...args);

  generateEPSPIDicomExtensionTask = (...args) =>
    this.recordApis.generateEPSPIDicomExtensionTask(...args);

  generateEBMWebviewerExtensionTask = (...args) =>
    this.recordApis.generateEBMWebviewerExtensionTask(...args);

  generateVetScanExtensionTask = (...args) =>
    this.recordApis.generateVetScanExtensionTask(...args);

  generateSynctoolGetLogTask = (...args) =>
    this.recordApis.generateSynctoolGetLogTask(...args);

  assignRecordStatus = (...args) => this.recordApis.assignRecordStatus(...args);

  fixExamTaskSubmitStatus = (...args) =>
    this.recordApis.fixExamTaskSubmitStatus(...args);

  saveDraftConflictLog = (...args) =>
    this.recordApis.saveDraftConflictLog(...args);

  uploadRecordFile = (...args) => this.recordApis.uploadRecordFile(...args);

  deleteRecordFile = (...args) => this.recordApis.deleteRecordFile(...args);

  confirmRecordFile = (...args) => this.recordApis.confirmRecordFile(...args);

  getRecordDateTime = (...args) => this.recordApis.getRecordDateTime(...args);

  getRecordHistoryDrug = (...args) =>
    this.recordApis.getRecordHistoryDrug(...args);
  //*********************  Form  *********************//
  getForm = async (...args) => {
    let res = await this.formApis.getForm(...args);
    if (res.code === 100000 && res.result)
      this.prependRecordResourcePath([res.result]);
    return res;
  };

  getFormListByPetID = async (...args) =>
    await this.formApis.getFormListByPetID(...args);

  createRecordEstimateForm = (...args) =>
    this.formApis.createRecordEstimateForm(...args);

  updateRecordEstimateForm = (...args) =>
    this.formApis.updateRecordEstimateForm(...args);

  copyEstimateRecord = (...args) =>
    this.formApis.copyRecordEstimateForm(...args);

  deleteForm = (...args) => this.formApis.deleteForm(...args);

  uploadFormFile = (...args) => this.formApis.uploadFormFile(...args);
  deleteFormFile = (...args) => this.formApis.deleteFormFile(...args);

  uploadErpFormFile = (...args) => this.formApis.uploadErpFormFile(...args);
  copyErpFormFile = (...args) => this.formApis.copyErpFormFile(...args);
  deleteErpFormFile = (...args) => this.formApis.deleteErpFormFile(...args);

  executeRecordEstimate = (...args) =>
    this.formApis.executeRecordEstimate(...args);

  //*********************  Ticket  *********************//
  generateRecordTicket = (...args) =>
    this.recordApis.generateRecordTicket(...args);

  //*********************  Pdf  *********************//
  getReportPDFByType = (...args) => this.pdfApis.getReportPDFByType(...args);
  getMultiReportPDF = (...args) => this.pdfApis.getMultiReportPDF(...args);
  getChargeRecordPDF = (...args) => this.pdfApis.getChargeRecordPDF(...args);

  //*********************  Csv  *********************//
  getCsvData = (...args) => this.csvApis.getCsvData(...args);
  getUserCsvData = (...args) => this.csvApis.getUserCsvData(...args);

  //*********************  Excel  *********************//
  getBillStatFile = (...args) => this.excelApis.getBillStatFile(...args);
  getCheckoutStatFile = (...args) =>
    this.excelApis.getCheckoutStatFile(...args);
  getBillStatFileByQueue = (...args) =>
    this.excelApis.getBillStatFileByQueue(...args);
  getBillStatFileLink = (...args) =>
    this.excelApis.getBillStatFileLink(...args);

  //*********************  IP  *********************//
  getIP = (...args) => this.ipApis.getIP(...args);

  //*********************  Todo  *********************//
  sendExamTaskRequest = (...args) => this.todoApis.sendExamTaskRequest(...args);

  updateExamTask = (...args) => this.todoApis.updateExamTask(...args);

  updateOutsourcingTask = (...args) =>
    this.todoApis.updateOutsourcingTask(...args);

  updateInsideTask = (...args) => this.todoApis.updateInsideTask(...args);

  updateDrugDispense = (...args) => this.todoApis.updateDrugDispense(...args);

  //*********************  Clockin  *********************//
  addClockin = (...args) => this.clockinApis.addClockin(...args);
  exportClockStat = (...args) => this.clockinApis.exportClockStat(...args);

  //*********************  InHospital v2 *********************//
  createInHospitalIfNeedVer2 = (...args) =>
    this.inHospitalV2Apis.createInHospitalIfNeedVer2(...args);
  getInHospital = (...args) => this.inHospitalV2Apis.getInHospital(...args);
  deleteInHospital = (...args) =>
    this.inHospitalV2Apis.deleteInHospital(...args);
  createInHospitalPlanVer2 = (...args) =>
    this.inHospitalV2Apis.createInHospitalPlanVer2(...args);
  updateInHospitalVer2 = (...args) =>
    this.inHospitalV2Apis.updateInHospitalVer2(...args);
  updateInHospitalPlanVer2 = (...args) =>
    this.inHospitalV2Apis.updateInHospitalPlanVer2(...args);
  deleteInHospitalByPlanDateTimeVer2 = (...args) =>
    this.inHospitalV2Apis.deleteInHospitalByPlanDateTimeVer2(...args);
  //整合至createInHospitalPlanVer2
  createInHospitalMissionLogVer2 = (...args) => {};
  getInHospitalMissionLogVer2 = (...args) =>
    this.inHospitalV2Apis.getInHospitalMissionLogVer2(...args);
  pushInHospitalMissionLogVer2 = (...args) =>
    this.inHospitalV2Apis.pushInHospitalMissionLogVer2(...args);
  modifyInHospitalMissionLogVer2 = (...args) =>
    this.inHospitalV2Apis.modifyInHospitalMissionLogVer2(...args);
  deleteInHospitalMissionLogVer2 = (...args) =>
    this.inHospitalV2Apis.deleteInHospitalMissionLogVer2(...args);
  createInHospitalExamVer2 = (...args) =>
    this.inHospitalV2Apis.createInHospitalExamVer2(...args);
  updateInHospitalExamVer2 = (...args) =>
    this.inHospitalV2Apis.updateInHospitalExamVer2(...args);
  getInHospitalExamVer2 = (...args) =>
    this.inHospitalV2Apis.getInHospitalExamVer2(...args);
  getInHospitalExamByPetVer2 = (...args) =>
    this.inHospitalV2Apis.getInHospitalExamByPetVer2(...args);
  //整合至deleteInHospitalMissionLogVer2
  deleteInHospitalExamVer2 = (...args) => {};
  getTodoInHospitalDrugListVer2 = (...args) =>
    this.inHospitalV2Apis.getTodoInHospitalDrugListVer2(...args);
  getTodoInHospitalExamListVer2 = (...args) =>
    this.inHospitalV2Apis.getTodoInHospitalExamListVer2(...args);
  getActiveInHospitalPlanVer2 = (...args) =>
    this.inHospitalV2Apis.getActiveInHospitalPlanVer2(...args);
  getActiveInHospitalMissionLogVer2 = (...args) =>
    this.inHospitalV2Apis.getActiveInHospitalMissionLogVer2(...args);
  getActiveInHospitalVer2 = (...args) =>
    this.inHospitalV2Apis.getActiveInHospitalVer2(...args);
  calInHospitalPlanTotalVer2 = (...args) =>
    inHospitalUtils.calInHospitalPlanTotalVer2(...args);
  getInHospitalListVer2 = (...args) =>
    this.inHospitalV2Apis.getInHospitalListVer2(...args);
  uploadInHospitalExamImgVer2 = (...args) =>
    this.inHospitalV2Apis.uploadInHospitalExamImgVer2(...args);
  deleteInHospitalExamImgVer2 = (...args) =>
    this.inHospitalV2Apis.deleteInHospitalExamImgVer2(...args);
  uploadInHospitalMissionLogImgVer2 = (...args) =>
    this.inHospitalV2Apis.uploadInHospitalMissionLogImgVer2(...args);
  deleteInHospitalMissionLogImgVer2 = (...args) =>
    this.inHospitalV2Apis.deleteInHospitalMissionLogImgVer2(...args);
  updateInHospitalDischargeVer2 = (...args) =>
    this.inHospitalV2Apis.updateInHospitalDischargeVer2(...args);
  getInHospitalListByPetVer2 = (...args) =>
    this.inHospitalV2Apis.getInHospitalListByPetVer2(...args);
  getInHospitalHistoryDrug = (...args) =>
    this.inHospitalV2Apis.getInHospitalHistoryDrug(...args);
  disableInHospitalDrug = (...args) =>
    this.inHospitalV2Apis.disableInHospitalDrug(...args);
  getDisableDrug = (...args) => this.inHospitalV2Apis.getDisableDrug(...args);
  //整合至其他API操作中
  deleteInHospitalReminder = (...args) => new Promise((resolve) => resolve());
  getInHospitalBilling = (...args) =>
    this.inHospitalV2Apis.getInHospitalBilling(...args);
  getInHospitalExamDateTime = (...args) =>
    this.inHospitalV2Apis.getInHospitalExamDateTime(...args);
  //*********************  InHospital  *********************//
  pushInHospitalMissionLog = (...args) =>
    this.inHospitalApis.pushInHospitalMissionLog(...args);
  modifyInHospitalMissionLog = (...args) =>
    this.inHospitalApis.modifyInHospitalMissionLog(...args);
  getInHospitalMonitor = (...args) =>
    this.inHospitalApis.getInHospitalMonitor(...args);
  setInHospitalMonitor = (...args) =>
    this.inHospitalApis.setInHospitalMonitor(...args);
  updateInHospital = (...args) => this.inHospitalApis.updateInHospital(...args);
  updateInHospitalSettle = (...args) =>
    this.inHospitalApis.updateInHospitalSettle(...args);
  updateInHospitalDischarge = (...args) =>
    this.inHospitalApis.updateInHospitalDischarge(...args);
  getActiveInHospitalMissionLog = (...args) =>
    this.inHospitalApis.getActiveInHospitalMissionLog(...args);
  getInHospitalQuotationPDF = (...args) =>
    this.inHospitalApis.getInHospitalQuotationPDF(...args);
  //*********************  Booking  *********************//
  createBooking = (...args) => this.bookingApis.createBooking(...args);
  deleteBooking = (...args) => this.bookingApis.deleteBooking(...args);
  deleteAllBooking = (...args) => this.bookingApis.deleteAllBooking(...args);
  getBooking = (...args) => this.bookingApis.getBooking(...args);
  getVerifyBooking = (...args) => this.bookingApis.getVerifyBooking(...args);
  getBookingListV2 = (...args) => this.bookingApis.getBookingListV2(...args);
  cancelBookingV2 = (...args) => this.bookingApis.cancelBookingV2(...args);
  approveBookingV2 = (...args) => this.bookingApis.approveBookingV2(...args);
  getBookingByDateRangeV2 = (...args) =>
    this.bookingApis.getBookingByDateRangeV2(...args);
  getBookingByDateRange = (...args) =>
    this.bookingApis.getBookingByDateRange(...args);
  getBookingList = (...args) => this.bookingApis.getBookingList(...args);
  modifyBooking = (...args) => this.bookingApis.modifyBooking(...args);
  bookingCheckIn = (...args) => this.bookingApis.bookingCheckIn(...args);
  isBookingCheckIn = (...args) => this.bookingApis.isBookingCheckIn(...args);
  checkBookingTime = (...args) => this.bookingApis.checkBookingTime(...args);
  revokeBookingCheckIn = (...args) =>
    this.bookingApis.revokeBookingCheckIn(...args);
  //*********************  Schedule  *********************//
  createSchedule = (...args) => this.scheduleApis.createSchedule(...args);
  getSchedule = (...args) => this.scheduleApis.getSchedule(...args);
  getScheduleById = (...args) => this.scheduleApis.getScheduleById(...args);
  deleteSchedule = (...args) => this.scheduleApis.deleteSchedule(...args);
  modifySchedule = (...args) => this.scheduleApis.modifySchedule(...args);
  //*********************  Referral  *********************//
  createReferral = (...args) => this.referralApis.createReferral(...args);
  deleteReferral = (...args) => this.referralApis.deleteReferral(...args);
  updateReferral = (...args) => this.referralApis.updateReferral(...args);
  getReferralList = (...args) => this.referralApis.getReferralList(...args);
  //********************* SurgeryMonitor ********************/
  getSurgeryMonitorByRecordID = (...args) =>
    this.surgeryMonitorApis.getSurgeryMonitorByRecordID(...args);
  appendSurgeryMonitor = (...args) =>
    this.surgeryMonitorApis.appendSurgeryMonitor(...args);
  modifySurgeryMonitorByRecordID = (...args) =>
    this.surgeryMonitorApis.modifySurgeryMonitorByRecordID(...args);
  //********************* Holiday ********************/
  getTodayHoliday = (...args) =>
    new Promise((resolve, reject) => {
      resolve({
        code: 100000,
        message: RTN_MSG["100000"],
        result: [],
      });
    });
  getHoliday = (...args) =>
    new Promise((resolve, reject) => {
      resolve({
        code: 100000,
        message: RTN_MSG["100000"],
        result: [],
      });
    });
  //********************* Payment ********************/
  getPaymentList = (...args) => this.paymentApis.getPaymentList(...args);
  //********************* Billing ********************/
  // updateReceive = (...args) => this.billingApis.updateReceive(...args);
  getReceiveLogByReceiveLogID = (...args) =>
    this.billingApis.getReceiveLogByReceiveLogID(...args);
  updateReceives = (...args) => this.billingApis.updateReceives(...args);
  editReceive = (...args) => this.billingApis.editReceive(...args);
  deleteReceive = (...args) => this.billingApis.deleteReceive(...args);
  getReceive = (...args) => this.billingApis.getReceive(...args);
  getReceiveStat = (...args) => this.billingApis.getReceiveStat(...args);
  getReceiveByConditions = (...args) =>
    this.billingApis.getReceiveByConditions(...args);
  exploreBilling = (...args) => this.billingApis.exploreBilling(...args);
  getBillingsByCondition = (...args) =>
    this.billingApis.getBillingsByCondition(...args);
  getUndoneBillings = (...args) => this.billingApis.getUndoneBillings(...args);
  getUndoneBillingsByPetID = (...args) =>
    this.billingApis.getUndoneBillingsByPetID(...args);
  getBillDistribution = (...args) =>
    this.billingApis.getBillDistribution(...args);
  saveBillBelongs = (...args) => this.billingApis.saveBillBelongs(...args);
  getBillBelongs = (...args) => this.billingApis.getBillBelongs(...args);
  //********************* SettingBooking ********************/
  getBookingSetting = (...args) =>
    this.settingBookingApis.getBookingSetting(...args);
  modifyBusinessHoursSetting = (...args) =>
    this.settingBookingApis.modifyBusinessHoursSetting(...args);
  modifyBookingPreferSetting = (...args) =>
    this.settingBookingApis.modifyBookingPreferSetting(...args);
  //********************* Sudo ********************/
  getClinicStaffRoleList = (...args) =>
    this.sudoApis.getClinicStaffRoleList(...args);
  getClinicList = (...args) => this.sudoApis.getClinicList(...args);
  //********************* Clinic ********************/
  getClinicDetail = (...args) => this.clinicApis.getClinicDetail(...args);
  updateClinicDetail = (...args) => this.clinicApis.updateClinicDetail(...args);
  uploadClinicFile = (...args) => this.clinicApis.uploadClinicFile(...args);
  deleteClinicFile = (...args) => this.clinicApis.deleteClinicFile(...args);
  getClinicFileList = (...args) => this.clinicApis.getClinicFileList(...args);
  //********************* Checkout ********************/
  getCheckout = (...args) => this.checkoutApis.getCheckout(...args);
  getCheckoutByCheckoutDate = (...args) =>
    this.checkoutApis.getCheckoutByCheckoutDate(...args);
  updateCheckout = (...args) => this.checkoutApis.updateCheckout(...args);
  getLastHandover = (...args) => this.checkoutApis.getLastHandover(...args);
  getPeriodIncome = (...args) => this.checkoutApis.getPeriodIncome(...args);
  //*********************  Customize  *********************//
  getCustomizeData = (...args) => this.customizeApis.getCustomizeData(...args);
  addCustomizeKind = (...args) =>
    this.customizeApis.addCustomizeData("kind", ...args);
  updateCustomizeKind = (...args) =>
    this.customizeApis.updateCustomizeData("kind", ...args);
  removeCustomizeKind = (...args) =>
    this.customizeApis.removeCustomizeData("kind", ...args);
  addCustomizeLabel = (...args) =>
    this.customizeApis.addCustomizeData("label", ...args);
  updateCustomizeLabel = (...args) =>
    this.customizeApis.updateCustomizeData("label", ...args);
  removeCustomizeLabel = (...args) =>
    this.customizeApis.removeCustomizeData("label", ...args);
  addCustomizeDisease = (...args) =>
    this.customizeApis.addCustomizeData("disease", ...args);
  updateCustomizeDisease = (...args) =>
    this.customizeApis.updateCustomizeData("disease", ...args);
  removeCustomizeDisease = (...args) =>
    this.customizeApis.removeCustomizeData("disease", ...args);
  addCustomizeService = (...args) =>
    this.customizeApis.addCustomizeData("service", ...args);
  updateCustomizeService = (...args) =>
    this.customizeApis.updateCustomizeData("service", ...args);
  removeCustomizeService = (...args) =>
    this.customizeApis.removeCustomizeData("service", ...args);
  addDefaultReminder = (...args) =>
    this.customizeApis.addDefaultReminder("reminder", ...args);
  addCustomizeReminder = (...args) =>
    this.customizeApis.addCustomizeData("reminder", ...args);
  updateCustomizeReminder = (...args) =>
    this.customizeApis.updateCustomizeData("reminder", ...args);
  removeCustomizeReminder = (...args) =>
    this.customizeApis.removeCustomizeData("reminder", ...args);

  //*********************  Customize Form *********************//

  getCustomizeFormUrl = (...args) =>
    this.customizeFormApis.getCustomizeFormUrl(...args);

  getGenericFormList = () => {
    let list = this.customizeFormApis.getGenericFormList();
    return {
      code: 100000,
      message: RTN_MSG["100000"],
      result: list,
    };
  };

  getCustomizeFormList = () => this.customizeFormApis.getCustomizeFormList();

  uploadCustomizeForm = (...args) =>
    this.customizeFormApis.uploadCustomizeForm(...args);

  createCustomizeForm = (...args) =>
    this.customizeFormApis.createCustomizeForm(...args);

  deleteCustomizeForm = (...args) =>
    this.customizeFormApis.deleteCustomizeForm(...args);

  deleteCustomizeFormFile = (...args) =>
    this.customizeFormApis.deleteCustomizeFormFile(...args);

  //*********************  prefixPath  *********************//
  getBreedImagePrefixPath = () => this.prefixPathApis.getBreedImagePrefixPath();
  getRecordImagePrefixPath = (...args) =>
    this.prefixPathApis.getRecordImagePrefixPath(...args);
  getInHospitalImagePrefixPathVer2 = (...args) =>
    this.prefixPathApis.getInHospitalImagePrefixPathVer2(...args);
  prependRecordResourcePath = (...args) =>
    this.prefixPathApis.prependRecordResourcePath(...args);

  //*********************  Staff roles  *********************//
  getRoleList = (...args) => this.roleApis.getRoleList(...args);
  createRole = (...args) => this.roleApis.createRole(...args);
  deleteRole = (...args) => this.roleApis.deleteRole(...args);
  updateRole = (...args) => this.roleApis.updateRole(...args);

  //*********************  Staff  *********************//
  createStaff = (...args) => this.staffApis.createStaff(...args);
  modifyStaff = (...args) => this.staffApis.modifyStaff(...args);
  modifyStaffPwd = (...args) => this.staffApis.modifyStaffPwd(...args);
  deleteStaff = (...args) => this.staffApis.deleteStaff(...args);
  getStaffList = (...args) => this.staffApis.getStaffList(...args);
  exportStaffList = (...args) => this.staffApis.exportStaffList(...args);
  uploadStaffAvatar = (...args) => this.staffApis.uploadStaffAvatar(...args);
  getStaffAvatar = (...args) => this.prefixPathApis.getStaffAvatar(...args);
  getDefaultStaffAvatar = () => this.prefixPathApis.getDefaultStaffAvatar();

  //*********************  User  *********************//
  getUser = (...args) => this.userApis.getUser(...args);
  createUser = (...args) => this.userApis.createUser(...args);
  modifyUser = (...args) => this.userApis.modifyUser(...args);
  deleteUser = (...args) => this.userApis.deleteUser(...args);
  getUserList = (...args) => this.userApis.getUserList(...args);
  searchUser = (...args) => this.userApis.searchUser(...args);
  getUserPage = (...args) => this.userApis.getUserPage(...args);
  deleteUserLine = (...args) => this.userApis.deleteUserLine(...args);
  sendLineMessage = (...args) => this.userApis.sendLineMessage(...args);
  passUserMessage = (...args) => this.userApis.passUserMessage(...args);
  touchUser = (...args) => this.userApis.touchUser(...args);

  //*********************  Pet  *********************//
  getPet = (...args) => this.petApis.getPet(...args);
  getPetListByUserID = (...args) => this.petApis.getPetListByUserID(...args);
  createPet = (...args) => this.petApis.createPet(...args);
  modifyPet = (...args) => this.petApis.modifyPet(...args);
  modifyPetParams = (...args) => this.petApis.modifyPetParams(...args);
  modifyPetBirth = (...args) => this.petApis.modifyPetBirth(...args);
  modifyPetTimeOfDeath = (...args) =>
    this.petApis.modifyPetTimeOfDeath(...args);
  deletePet = (...args) => this.petApis.deletePet(...args);
  getPetList = (...args) => this.petApis.getPetList(...args);
  getListPageWithQuery = (...args) =>
    this.petApis.getListPageWithQuery(...args);
  getPetDetailByParams = (...args) =>
    this.petApis.getPetDetailByParams(...args);
  searchPet = (...args) => this.petApis.searchPet(...args);
  simpleSearchPet = (...args) => this.petApis.simpleSearchPet(...args);
  getPetPage = (...args) => this.petApis.getPetPage(...args);
  addPetWeight = (...args) => this.petApis.addPetWeight(...args);
  updatePetWeight = (...args) => this.petApis.updatePetWeight(...args);
  deletePetWeight = (...args) => this.petApis.deletePetWeight(...args);
  touchUserAndPet = (...args) => this.petApis.touchUserAndPet(...args);
  touchPet = (...args) => this.petApis.touchPet(...args);

  updatePetIDCounter = (...args) => this.petApis.updatePetIDCounter(...args);
  uploadPetAvatar = (...args) => this.petApis.uploadPetAvatar(...args);
  getPetAvatar = (...args) => this.prefixPathApis.getPetAvatar(...args);
  getDefaultPetAvatar = (...args) =>
    this.prefixPathApis.getDefaultPetAvatar(...args);

  uploadBreedAvatar = (...args) => this.petApis.uploadBreedAvatar(...args);
  renamePetID = (...args) => this.petApis.renamePetID(...args);
  combinePet = (...args) => this.petApis.combinePet(...args);

  //*********************  Reminder  *********************//
  getAllReminder = (...args) => this.reminderApis.getAllReminder(...args);
  searchReminder = (...args) => this.reminderApis.searchReminder(...args);
  addReminderV2 = (...args) => this.reminderApis.addReminder(...args);
  updateReminderV2 = (...args) => this.reminderApis.updateReminder(...args);
  closeReminder = (...args) => this.reminderApis.closeReminder(...args);
  notifiedReminder = (...args) => this.reminderApis.notifiedReminder(...args);
  batchNotifiedReminder = (...args) =>
    this.reminderApis.batchNotifiedReminder(...args);

  deleteReminderV2 = (...args) => this.reminderApis.deleteReminder(...args);
  deleteReminderByPet = (...args) =>
    this.reminderApis.deleteReminderByPet(...args);

  remindUser = (...args) => this.reminderApis.remindUser(...args);
  getRecordReminder = (...args) => this.reminderApis.getRecordReminder(...args);
  getPetReminder = (...args) => this.reminderApis.getPetReminder(...args);
  getReminderTemplate = (...args) =>
    this.reminderApis.getReminderTemplate(...args);
  //*********************  Config  *********************//
  // getSocketChangeWhiteList = (...args) =>
  //   this.configApis.getSocketChangeWhiteList(...args);

  //*********************  Setting  *********************//
  getSetting = (...args) => this.settingApis.getSetting(...args);
  updateOrderSeries = (...args) => this.settingApis.updateOrderSeries(...args);
  updateSetting = (...args) => this.settingApis.updateSetting(...args);
  getTreatmentSetting = (...args) =>
    this.settingApis.getTreatmentSetting(...args);
  updateTreatmentSetting = (...args) =>
    this.settingApis.updateTreatmentSetting(...args);
  updatePrintSetting = (...args) =>
    this.settingApis.updatePrintSetting(...args);
  getBackupUrl = (...args) => this.settingApis.getBackupUrl(...args);
  //*********************  Web  *********************//
  getSettingWeb = (...args) => this.webApis.getSettingWeb(...args);
  getDocWeb = (...args) => this.webApis.getDocWeb(...args);

  uploadRecordImgWeb = (...args) => this.webApis.uploadRecordImgWeb(...args);
  uploadFormFileWeb = (...args) => this.webApis.uploadFormFileWeb(...args);
  uploadERPFormFileWeb = (...args) =>
    this.webApis.uploadERPFormFileWeb(...args);
  deleteRecordImgWeb = (...args) => this.webApis.deleteRecordImgWeb(...args);

  //*********************  Common  *********************//
  // getFocusClinic = () => {
  //   return getFocusClinic();
  // };

  // getEmulateUser = () => {
  //   return getEmulateUser();
  // };

  updatePrint = (...args) => {
    return updatePrint(...args);
  };

  getPrintData = () => {
    return getPrintData();
  };

  hasBillItem = (...args) => {
    return hasBillItem(...args);
  };

  b64toBlob = (...args) => {
    return b64toBlob(...args);
  };

  //*********************  Emun  *********************//
  getPetStatusList = () => {
    return PET_STATUS_LIST;
  };

  getLigationList = () => {
    return PET_LIGATION_LIST;
  };

  getGenderList = () => {
    return PET_GENDER_LIST;
  };

  //*********************  Synctool  *********************//
  getSynctoolList = (...args) => this.synctoolApis.getSynctoolList(...args);
  updateSynctoolName = (...args) =>
    this.synctoolApis.updateSynctoolName(...args);
  deleteSynctool = (...args) => this.synctoolApis.deleteSynctool(...args);
  sendAbaxisTest = (...args) => this.synctoolApis.sendAbaxisTest(...args);
  getAbaxisPdf = (...args) => this.synctoolApis.getAbaxisPdf(...args);
  //*********************  System  *********************//
  getApiServerHost = () => {
    return this.apiEndpoint;
  };

  setApiServerHost = (host) => {
    this.setApiEndpoint(host);
  };

  getServerWebHost = () => {
    return this.webEndpoint;
  };

  getServerHost = () => {
    return this.dbEndpoint;
  };

  setServerHost = (host) => {
    this.dbEndpoint = host;
  };

  //*********************  basic  *********************//
  getVersion = () => this.basicApis.getVersion();

  login = (...args) => this.basicApis.login(...args);

  setOptClinic(clinic) {
    localStorage.setItem("CLINIC", clinic);
    console.log(`set operate clinic:${clinic}`);
  }
  getOptClinic() {
    return localStorage.getItem("CLINIC");
  }

  verify = () => this.basicApis.verify();

  checkLogin() {
    return localStorage.getItem("JWT");
  }

  tokenEmulator = async (clinic, staffID) => {
    let res = await this.sudoApis.tokenEmulator(clinic, staffID);
    if (res.result && res.result.jwt) {
      // console.log("write jwt to sessionStorage");
      localStorage.setItem("JWT", res.result.jwt);
      console.log(`set operate clinic:${clinic}`);
      localStorage.setItem("CLINIC", clinic);
    }

    return res;
  };

  logout() {
    localStorage.removeItem("LAST_USERNAME");
    localStorage.removeItem("LAST_PASSWORD");
    localStorage.removeItem("LAST_NAME");
    localStorage.removeItem("LAST_REMOTE_MODE");
    localStorage.removeItem("CLINIC");
    localStorage.removeItem("AUTH_CLINICS");
    localStorage.removeItem("SYSTEM_ROLE");
    localStorage.removeItem("EMULATE_USER");

    localStorage.removeItem("JWT");
  }

  //*********************  Deposit  *********************//
  getDeposit = (...args) => this.depositApis.getDeposit(...args);
  addDepositLog = (...args) => this.depositApis.addDepositLog(...args);
  getDepositLogsByDate = (...args) =>
    this.depositApis.getDepositLogsByDate(...args);
  getDepositLogsByConditions = (...args) =>
    this.depositApis.getDepositLogsByConditions(...args);
  getDepositLogByUserIDAndDateTime = (...args) =>
    this.depositApis.getDepositLogByUserIDAndDateTime(...args);
  editDepositLog = (...args) => this.depositApis.editDepositLog(...args);
  deleteDeposit = (...args) => this.depositApis.deleteDeposit(...args);

  //*********************  Exam  *********************//
  lastDeviceExamList = (...args) => this.examApis.lastDeviceExamList(...args);
  getAllList = (...args) => this.examApis.getAllList(...args);
  loadRecordAttachCandidate = (...args) =>
    this.examApis.loadRecordAttachCandidate(...args);
  loadInHospitalAttachCandidate = (...args) =>
    this.examApis.loadInHospitalAttachCandidate(...args);
  examAttach = (...args) => this.examApis.examAttach(...args);
  deleteExams = (...args) => this.examApis.deleteExams(...args);
  getExamDeviceByAttachedID = (...args) =>
    this.examApis.getExamDeviceByAttachedID(...args);
  getExamDeviceByPetID = (...args) =>
    this.examApis.getExamDeviceByPetID(...args);
  updateExamDeviceResults = (...args) =>
    this.examApis.updateExamDeviceResults(...args);
  getExamCountByDate = (...args) => this.examApis.getExamCountByDate(...args);
  getExamReportUrl = (...args) => this.examApis.getExamReportUrl(...args);

  //*********************  External  *********************//
  getClinicToken = (...args) => this.externalApis.getClinicToken(...args);
  getClinicRoom = (...args) => this.externalApis.getClinicRoom(...args);
  callNumber = (...args) => this.externalApis.callNumber(...args);
  setAppointment = (...args) => this.externalApis.setAppointment(...args);
  getImageDetection = (...args) => this.externalApis.getImageDetection(...args);
  getAiLabel = (...args) => this.externalApis.getAiLabel(...args);
  getAnImageDetection = (...args) =>
    this.externalApis.getAnImageDetection(...args);
  getSciKetToken = (...args) => this.externalApis.getSciKetToken(...args);
  getSciKetToken = (...args) => this.externalApis.getSciKetToken(...args);
  sendSMS = (...args) => this.externalApis.sendSMS(...args);
  getSmsPoint = (...args) => this.externalApis.getSmsPoint(...args);
  getScrmMessages = (...args) => this.externalApis.getScrmMessages(...args);
  getScrmSetting = (...args) => this.externalApis.getScrmSetting(...args);
  getTerrymonLabelList = (...args) =>
    this.externalApis.getTerrymonLabelList(...args);
  createBreezySignByPDF = (...args) =>
    this.externalApis.createBreezySignByPDF(...args);
  createBreezySignByDocx = (...args) =>
    this.externalApis.createBreezySignByDocx(...args);

  //*********************  Verify  *********************//
  getVerify = (...args) => this.verifyApis.getVerify(...args);
  createVerify = (...args) => this.verifyApis.createVerify(...args);
  modifyVerify = (...args) => this.verifyApis.modifyVerify(...args);
  deleteVerify = (...args) => this.verifyApis.deleteVerify(...args);
  fakeDeleteVerify = (...args) => this.verifyApis.fakeDeleteVerify(...args);
  getVerifyByPet = (...args) => this.verifyApis.getVerifyByPet(...args);
  getVerifyListByPet = (...args) => this.verifyApis.getVerifyListByPet(...args);
  getVerifyList = (...args) => this.verifyApis.getVerifyList(...args);

  //*********************  Verify V2  *********************//
  getVerifyV2 = (...args) => this.verifyV2Apis.getVerify(...args);
  createVerifyV2 = (...args) => this.verifyV2Apis.createVerify(...args);
  modifyVerifyV2 = (...args) => this.verifyV2Apis.modifyVerify(...args);
  deleteVerifyV2 = (...args) => this.verifyV2Apis.deleteVerify(...args);
  fakeDeleteVerifyV2 = (...args) => this.verifyV2Apis.fakeDeleteVerify(...args);
  getVerifyByPetV2 = (...args) => this.verifyV2Apis.getVerifyByPet(...args);
  getVerifyListByPetV2 = (...args) =>
    this.verifyV2Apis.getVerifyListByPet(...args);
  getVerifyListV2 = (...args) => this.verifyV2Apis.getVerifyList(...args);
  associateVerifyWithBookingId = (...args) =>
    this.verifyV2Apis.associateVerifyWithBookingId(...args);

  //*********************  alliance  *********************//
  //*******  user & pet *******//
  searchAllianceUser = (...args) =>
    this.allianceApis.searchAllianceUser(...args);
  getAllianceUserList = (...args) =>
    this.allianceApis.getAllianceUserList(...args);
  getAllianceUser = (...args) => this.allianceApis.getAllianceUser(...args);
  getAllianceBulkUser = (...args) =>
    this.allianceApis.getAllianceBulkUser(...args);
  getAlliancePet = (...args) => this.allianceApis.getAlliancePet(...args);
  getAlliancePetsByUser = (...args) =>
    this.allianceApis.getAlliancePetsByUser(...args);

  //*******  records *******//
  getAllianceRecordListByPet = (...args) =>
    this.allianceApis.getAllianceRecordListByPet(...args);
  getAllianceInHospitalExamByPetVer2 = (...args) =>
    this.allianceApis.getAllianceInHospitalExamByPetVer2(...args);
  getAllianceInHospitalListByPetVer2 = (...args) =>
    this.allianceApis.getAllianceInHospitalListByPetVer2(...args);
  getAllianceExamDeviceByPetID = (...args) =>
    this.allianceApis.getAllianceExamDeviceByPetID(...args);
  getAllianceReferralList = (...args) =>
    this.allianceApis.getAllianceReferralList(...args);
  // getAllianceFormListByPetID = (...args) =>
  //   this.allianceApis.getAllianceFormListByPetID(...args);
  getAllianceBookingList = (...args) =>
    this.allianceApis.getAllianceBookingList(...args);
  getAllianceDeposit = (...args) =>
    this.allianceApis.getAllianceDeposit(...args);

  getAllianceUndoneBillings = (...args) =>
    this.allianceApis.getAllianceUndoneBillings(...args);
  // getAllianceUndoneBillingsByPetID = (...args) =>
  //   this.allianceApis.getAllianceUndoneBillingsByPetID(...args);

  //*******  settings *******//
  getAllianceClinics = (...args) =>
    this.allianceApis.getAllianceClinics(...args);

  //*********************  linepay  *********************//
  createLinePayPayment = (...args) =>
    this.linepayApis.createLinePayPayment(...args);
  confirmLinePay = (...args) => this.linepayApis.confirmLinePay(...args);
  checkLinePayPayment = (...args) =>
    this.linepayApis.checkLinePayPayment(...args);
  cancelLinePayPayment = (...args) =>
    this.linepayApis.cancelLinePayPayment(...args);

  //*******  webLog *******//
  webLog = (...args) => this.webLogApis.webLog(...args);

  //*********************  Service  *********************//
  exportServiceList = (...args) => this.serviceApis.exportServiceList(...args);
  //*********************  Supplier  *********************//
  exportSupplierList = (...args) =>
    this.supplierApis.exportSupplierList(...args);
  //*********************  Product  *********************//
  exportProductList = (...args) => this.productApis.exportProductList(...args);

  //*********************  PetFile  *********************//
  getPetFilesById = (...args) => this.petFileApis.getPetFilesById(...args);
  addPetFilesById = (...args) => this.petFileApis.addPetFilesById(...args);
  addPetFilesByIdByPhone = (...args) =>
    this.petFileApis.addPetFilesByIdByPhone(...args);
  updatePetFilesByIdAndTs = (...args) =>
    this.petFileApis.updatePetFilesByIdAndTs(...args);
  deletePetFilesByIdAndTs = (...args) =>
    this.petFileApis.deletePetFilesByIdAndTs(...args);
  deleteSinglePetFileById = (...args) =>
    this.petFileApis.deleteSinglePetFileById(...args);

  //*********************  Oauth  *********************//
  getOauthCode = (...args) => this.oauthApis.getOauthCode(...args);
}

export default SDK;
